// extracted by mini-css-extract-plugin
module.exports = {"contactButton":"HomeSettings_contactButton__6rcFp","aboutButton":"HomeSettings_aboutButton__vhG4k"};